// extracted by mini-css-extract-plugin
export var accent = "_8s-4";
export var add = "_8s-j";
export var addIcon = "_8s-k";
export var deleteIcon = "_8s-i";
export var disabled = "_8s-9";
export var ellipsis = "_8s-f";
export var error = "_8s-3";
export var form = "_8s-5";
export var hideFocus = "_8s-2";
export var icon = "_8s-7";
export var input = "_8s-e";
export var listItem = "_8s-h";
export var mediumHeight = "_8s-b";
export var noBorder = "_8s-8";
export var noRadius = "_8s-1";
export var shortHeight = "_8s-a";
export var tallHeight = "_8s-c";
export var textInput = "_8s-0";
export var vertical = "_8s-g";
export var veryTallHeight = "_8s-d";
export var widget = "_8s-6";